import { cartQuery } from '@/api/carts/cartQueries';
import {
  SlimTable,
  SlimTableBody,
  SlimTableCell,
  SlimTableHead,
  SlimTableHeader,
  SlimTableRow,
} from '@/components/common/SlimTable';
import { useQuery } from '@tanstack/react-query';

interface CartItemsCardProps {
  cartId: number;
}

export const CartItemsCard = ({ cartId }: CartItemsCardProps) => {
  const { data: cart } = useQuery(cartQuery(cartId));

  return (
    <div className="my-4 max-w-125 rounded-xl bg-[#eeeeee] px-5 py-2.5">
      <SlimTable>
        <SlimTableHeader>
          <SlimTableRow className="text-[#777777]">
            <SlimTableHead>Supplement</SlimTableHead>
            <SlimTableHead>Dose</SlimTableHead>
            <SlimTableHead className="text-right whitespace-nowrap">
              30 pills
            </SlimTableHead>
          </SlimTableRow>
        </SlimTableHeader>

        <SlimTableBody>
          {cart?.data.items?.map((cartItem) => (
            <SlimTableRow key={cartItem.id}>
              <SlimTableCell>
                {cartItem.item_price.item?.name || 'Supplement'}
              </SlimTableCell>
              <SlimTableCell>{cartItem.item_price.strength}</SlimTableCell>
              <SlimTableCell className="text-center">
                {cartItem.quantity}
              </SlimTableCell>
            </SlimTableRow>
          ))}
        </SlimTableBody>
      </SlimTable>
    </div>
  );
};
